import React from 'react';
import { useMediaQuery } from '@sparknz/spark-pattern-library';

import { CardCarousel } from 'components/shop/shared/components';
import { CardCarouselProps } from 'components/shop/shared/components/CardCarousel';

interface PlanCardsContainerProps extends CardCarouselProps {
  forceCarousel: boolean;
}

const PlanCardsContainer = ({
  children,
  numberOfCards,
  activeCategories,
  regionId,
  forceCarousel,
}: PlanCardsContainerProps) => {
  const isMobileView = useMediaQuery({ max: 'lil' });

  if (forceCarousel) {
    return (
      <CardCarousel
        numberOfCards={numberOfCards}
        activeCategories={activeCategories}
        regionId={regionId}
      >
        {children}
      </CardCarousel>
    );
  }

  return isMobileView ? (
    <>{children}</>
  ) : (
    <CardCarousel
      numberOfCards={numberOfCards}
      activeCategories={activeCategories}
      regionId={regionId}
    >
      {children}
    </CardCarousel>
  );
};

export default PlanCardsContainer;
